import store from 'src/store/store'
import * as XLSX from 'xlsx-js-style'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import {
  getFaceSheetCurrentPageNo,
  getIntakeCurrentPageNo,
  getIsFaceSheetCompleted,
  getIsIntakeCompleted,
  getIsPreSectionCompleted,
  getPreSectionCurrentPageNo,
  getQ158Answer,
  getQ240Answer,
} from './core'
import { filter, find, findIndex, findLastIndex } from 'lodash'

export const saveUserDetails = (userData) => {
  window.sessionStorage.setItem('token', userData.token)
  window.sessionStorage.setItem('role', userData.role)
  window.sessionStorage.setItem('isAllied', userData?.isAllied || false)
  window.sessionStorage.setItem('name', userData?.name)
}

export const removeUserDetails = () => {
  window.sessionStorage.removeItem('token')
  window.sessionStorage.removeItem('role')
  window.sessionStorage.removeItem('isAllied')
  window.sessionStorage.removeItem('endPage')
  window.sessionStorage.removeItem('name')
}

export const getMonths = () => {
  const language = localStorage.getItem('language') || '1'
  return Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    value: new Date(0, i).toLocaleString('en-US', { month: 'long' }),
    label: new Date(0, i).toLocaleString(language === '1' ? 'en-US' : 'es-ES', { month: 'long' }),
  }))
}

export const getYears = (startYear) => {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i)
}

export const transformQuestions = (questions, isFeedback, preValues) => {
  const postResponse = (question, ind, additionalNotes) => {
    const response = []
    const allattorneyList = filter(questions, ['ddl_questiontype', 21])
    const lastAttorneyIndex = findLastIndex(questions, ['ddl_questiontype', 21])
    if (question.recordid) {
      response.push({
        qId: question.recordid,
        qType: question.ddl_questiontype,
        response1: String(question.answer?.answer1) || '',
        response2:
          question.ddl_questiontype === 22 && !question.answer?.answer1
            ? ''
            : String(question.answer?.answer2) || '',
        response3: String(question.answer?.answer3) || '',
        response4: String(question.answer?.answer4) || '',
        response5: String(question.answer?.answer5) || '',
        response6: String(question.answer?.answer6) || '',
        response7: String(question.answer?.answer7) || '',
        response8: String(question.answer?.answer8) || '',
        response9: '',
        response10: isFeedback ? preValues?.FeedbackSource : '',
        additionalNotes: isFeedback
          ? preValues?.FeedbackSource === '4'
            ? preValues?.Feedbackoptionother
            : preValues?.Feedbackoption
          : [20, 22, 23].includes(question.ddl_questiontype)
            ? `${questions.length}_${ind + 1}`
            : question.ddl_questiontype === 21
              ? `${allattorneyList.length}_${allattorneyList?.length + (ind - lastAttorneyIndex)}`
              : additionalNotes && typeof additionalNotes !== 'object'
                ? additionalNotes
                : '',
      })
    }
    if (question.choice1) {
      question.choice1.forEach((choice) => {
        if (choice.childQuestion) {
          choice.childQuestion.forEach((subChild) => {
            const condition =
              question.ddl_questiontype == 21 && question.answer?.answer4 == choice.recordid
            if (
              question.answer?.answer1 == choice.recordid ||
              question.ddl_questiontype == 6 ||
              condition
            ) {
              let additionalNotes = ''
              if (condition) {
                additionalNotes = `${allattorneyList.length}_${allattorneyList?.length + (ind - lastAttorneyIndex)}`
              }
              response.push(...postResponse(subChild, ind, additionalNotes))
            }
          })
        }
      })
    }
    if (question.choice2) {
      question.choice2.forEach((choice) => {
        if (choice.childQuestion) {
          choice.childQuestion.forEach((subChild) => {
            if (question.ddl_questiontype == 21 && question.answer?.answer5 == choice.recordid) {
              const additionalNotes = `${allattorneyList.length}_${allattorneyList?.length + (ind - lastAttorneyIndex)}`
              response.push(...postResponse(subChild, ind, additionalNotes))
            }
          })
        }
      })
    }
    return response
  }
  return questions.flatMap(postResponse)
}

export const transformAnswers = (questions, responses, addMoreRecordId = 0, isChild = false) => {
  const oneMoreResponce = filter(responses, ['qId', addMoreRecordId])
  const startIndex = findIndex(questions, ['recordid', addMoreRecordId])
  if (oneMoreResponce?.length > 1 && startIndex > -1 && !isChild) {
    const updateChildQuestions = (choices, additionalNotes) => {
      if (choices) {
        choices.forEach((choice) => {
          if (choice.childQuestion) {
            choice.childQuestion.forEach((child) => {
              child.additionalNotes = additionalNotes
            })
          }
        })
      }
    }
    oneMoreResponce.slice(1).map((_, index) => {
      const newQuestion = JSON.parse(JSON.stringify(questions[startIndex]))
      const additionalNotes = `${oneMoreResponce?.length}_${index + 2}`
      updateChildQuestions(newQuestion.choice1, additionalNotes)
      updateChildQuestions(newQuestion.choice2, additionalNotes)
      newQuestion.additionalNotes = additionalNotes
      questions.splice(startIndex + index + 1, 0, newQuestion)
    })
  }
  questions.forEach((question) => {
    if (question.answer) {
      question.answer.ddl_questiontype = question.ddl_questiontype || 0
      let matchingResponse = false
      if (question?.additionalNotes && question.recordid === addMoreRecordId) {
        matchingResponse = find(responses, {
          qId: question.recordid,
          additionalNotes: question.additionalNotes,
        })
      } else {
        matchingResponse = responses.find((response) => response.qId === question.recordid)
      }
      if (matchingResponse) {
        question.answer.answer1 = matchingResponse.response1 || ''
        question.answer.answer2 = matchingResponse.response2 || ''
        question.answer.answer3 = matchingResponse.response3 || ''
        question.answer.answer4 = matchingResponse.response4 || ''
        question.answer.answer5 = matchingResponse.response5 || ''
        question.answer.answer6 = matchingResponse.response6 || ''
        question.answer.answer7 = matchingResponse.response7 || ''
        question.answer.answer8 = matchingResponse.response8 || ''
        question.answer.answer9 = matchingResponse.response9 || ''
        question.answer.answer10 = matchingResponse.response10 || ''
      }
    }
    if (question.choice1) {
      question.choice1.forEach((choice, ind) => {
        if (choice.childQuestion) {
          const childIds = [97, 98, 99, 100]
          const childRecordId = find(choice.childQuestion, (child) =>
            childIds.includes(child.recordid),
          )?.recordid
          question.choice1[ind].isChildQuestion = true
          transformAnswers(choice.childQuestion, responses, childRecordId, true)
        } else {
          question.choice1[ind].isChildQuestion = false
        }
      })
    }
    if (question.choice2) {
      question.choice2.forEach((choice, ind) => {
        if (choice.childQuestion) {
          const childIds = [101, 102, 103, 104]
          const childRecordId = find(choice.childQuestion, (child) =>
            childIds.includes(child.recordid),
          )?.recordid
          question.choice2[ind].isChildQuestion = true
          transformAnswers(choice.childQuestion, responses, childRecordId, true)
        } else {
          question.choice2[ind].isChildQuestion = false
        }
      })
    }
    if (question.html_questiontext.includes('#13b_no_text#')) {
      const storedValue = getQ240Answer.get()
      question.html_questiontext = question.html_questiontext.replace(
        '#13b_no_text#',
        questionStrings()[parseInt(storedValue === 'more than 10' ? 11 : storedValue, 10) - 1] ||
          '#13b_no_text#',
      )
    } else if (question.html_questiontext.includes('#events#')) {
      const storedValue = getQ158Answer.get()
      question.html_questiontext = question.html_questiontext.replace(
        '#events#',
        `${storedValue}` || '#events#',
      )
    }
  })
  return questions
}

export const getRecordIds = (questions) => {
  const ids = []
  const extractRecordIds = (question) => {
    if (question.recordid && question.answer) {
      if (!ids.includes(question.recordid)) {
        ids.push(question.recordid)
      }
    }

    if (question.choice1) {
      question.choice1.forEach((choice) => {
        if (choice.childQuestion) {
          choice.childQuestion.forEach((subChild) => {
            extractRecordIds(subChild)
          })
        }
      })
    }
    if (question.choice2) {
      question.choice2.forEach((choice) => {
        if (choice.childQuestion) {
          choice.childQuestion.forEach((subChild) => {
            extractRecordIds(subChild)
          })
        }
      })
    }
  }
  questions.forEach((question) => {
    extractRecordIds(question)
  })
  return ids
}

export const replaceLastPathElement = (name, replaceValue, num = 1) => {
  let splitPath = name.split('.')
  splitPath.splice(-num, num, replaceValue)
  return splitPath.join('.')
}

const questionStrings = () => {
  const language = localStorage.getItem('language') || '1'
  const questionStringsEnglish = [
    'Happened in the prior controlling/ hurtful relationship?',
    'Happened in either of the prior controlling/hurtful relationships?',
    'Happened in any of the 3 prior controlling/hurtful relationships?',
    'Happened in any of the 4 prior controlling/hurtful relationships?',
    'Happened in any of the 5 prior controlling/hurtful relationships?',
    'Happened in any of the 6 prior controlling/hurtful relationships?',
    'Happened in any of the 7 prior controlling/hurtful relationships?',
    'Happened in any of the 8 prior controlling/hurtful relationships?',
    'Happened in any of the 9 prior controlling/hurtful relationships?',
    'Happened in any of the 10 prior controlling/hurtful relationships?',
    'Happened in any of the more than 10 prior controlling/hurtful relationships?',
  ]
  const questionStringsSpanish = [
    '¿Qué sucedió en la relación anterior de control/dolorosa?',
    '¿Qué sucedió en alguna de las relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 3 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 4 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 5 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 6 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 7 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 8 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 9 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las 10 relaciones anteriores de control/dolorosas?',
    '¿Qué sucedió en alguna de las más de 10 relaciones anteriores de control/dolorosas?',
  ]
  return language === '1' ? questionStringsEnglish : questionStringsSpanish
}

export const scrollToError = (errors) => {
  const firstError = Object.keys(errors)[0]
  const errorField = document.querySelector(`[name="${firstError}"]`)
  if (errorField) {
    errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
    errorField.focus()
  }
}

export const storage = {
  getmapDetails: (key) => {
    const clientDetails = JSON.parse(localStorage.getItem('clientDetails'))
    return clientDetails?.[key]
  },
  setmapDetails: (key, value) => {
    const clientDetails = JSON.parse(localStorage.getItem('clientDetails'))
    clientDetails[key] = value
    return localStorage.setItem('clientDetails', JSON.stringify(clientDetails))
  },
  get: (key) => {
    return JSON.parse(localStorage.getItem(key))
  },
  set: (key, token) => {
    localStorage.setItem(key, JSON.stringify(token))
  },
  clear: () => {
    localStorage.clear()
  },
}

export const getRedirectUrl = () => {
  const isFaceSheetCompleted = getIsFaceSheetCompleted.get()
  const isPreSectionCompleted = getIsPreSectionCompleted.get()
  const isIntakeCompleted = getIsIntakeCompleted.get()

  const faceSheetCurrentPageNo = getFaceSheetCurrentPageNo.get()
  const preSectionCurrentPageNo = getPreSectionCurrentPageNo.get()
  const intakeCurrentPageNo = getIntakeCurrentPageNo.get()

  if (!isFaceSheetCompleted) {
    return `facesheet/${faceSheetCurrentPageNo}`
  } else if (!isPreSectionCompleted && preSectionCurrentPageNo !== 0) {
    return `presection/${preSectionCurrentPageNo}`
  } else if (!isIntakeCompleted) {
    return `intake/${intakeCurrentPageNo}`
  } else {
    return `conclusion`
  }
}

export const autoResize = (element) => {
  if (element) {
    element.style.height = 'auto'
    element.style.height = element.scrollHeight + 'px'
  }
}

export const formatDate = (dateString) => {
  const language = localStorage.getItem('language') || '1'
  const date = new Date(dateString)

  if (isNaN(date.getTime())) return ''

  return date.toLocaleDateString(language === '1' ? 'en-US' : 'es-ES', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}
export const fullFormatDate = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const formatDateAndTime = (dateString) => {
  const language = localStorage.getItem('language') || '1'
  const date = new Date(dateString)
  const formattedDate = date.toLocaleDateString(language === '1' ? 'en-US' : 'es-ES', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
  const formattedTime = date
    .toLocaleTimeString(language === '1' ? 'en-US' : 'es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .toUpperCase()
  return `${formattedDate} ${formattedTime}`
}
export const handleUrl = () => {
  const role = window.sessionStorage.getItem('role')
  if (role === 'C') {
    return `/client/${getRedirectUrl()}`
  } else {
    return '/forclients'
  }
}

export const getRequired = () => {
  const requiredMessage = store?.getState().generalData?.txt_requiredmessage
  return requiredMessage
}

export const getEmaiValidation = () => {
  const emailValidationMessage = store?.getState().generalData?.txt_emailvalidationtext
  return emailValidationMessage
}

export const handleLinkClick = (e, navigate) => {
  e.preventDefault()
  const link = e.target.closest('a')
  if (!link) return
  let href = link.getAttribute('href')
  if (!href || href === '#') return
  const target = link.getAttribute('target')
  if (/^(https?:|mailto:)/.test(href)) {
    target === '_blank' ? window.open(href, '_blank') : (window.location.href = href)
  } else if (href.includes('DM_Files/') && href.includes('.')) {
    target === '_blank' ? window.open(href, '_blank') : (window.location.href = href)
  } else if (href.includes('DM_Files/')) {
    href = href + '.pdf'
    target === '_blank' ? window.open(href, '_blank') : (window.location.href = href)
  } else if (href.startsWith('faqs#')) {
    navigate(`/faqs${href.substring(4)}`)
  } else {
    const path = href.startsWith('/') ? href : new URL(href, window.location.href).pathname
    target === '_blank' ? window.open(href, '_blank') : navigate(path)
    if (href.startsWith('#')) document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' })
  }
}

export const handleOpenModel = (e) => {
  const link = e.target.closest('a')
  if (!link) return
  e.preventDefault()
  const modalLink = link.getAttribute('data-target') || link.getAttribute('href')
  return modalLink
}

export const convertToISOFormat = (submittedTime) => {
  const dateObj = new Date(submittedTime.replace(' ', 'T'))
  const year = dateObj.getFullYear()
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')
  const hours = String(dateObj.getHours()).padStart(2, '0')
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  const seconds = String(dateObj.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

export const getFormattedDate = () => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  return new Date().toLocaleDateString('en-US', options)
}

export const getFormattedExportData = (data, exportColumns, name) => {
  return data.map((item) => {
    const formatted = {}
    exportColumns.forEach((col) => {
      switch (col.key) {
        case 'clientContact':
          const email = item.email
          const phone = item.phoneNo
          const county = item.county
          const state = item.state
          const country = item.country
          const addressFields = [county, state, country].filter(Boolean)
          const address = addressFields.length ? `(${addressFields.join(', ')})` : ''
          const contactLine = [email, phone].filter(Boolean).join('; ')
          formatted[col.label] = [address, contactLine].filter(Boolean).join('\n')
          break

        case 'createdOn':
          formatted[col.label] = item[col.key] ? formatDate(item[col.key]) : ''
          break

        case 'attorneyName':
          formatted[col.label] =
            `${item.attorneyFirstname || ''} ${item.attorneyLastname || ''}`.trim()
          break

        case 'caseTypeShortName':
          let caseType =
            item.intakeTypeName === 'Uploaded map'
              ? item.intakeTypeName
              : item.caseTypeShortName || ''

          let language = ''
          if (item.languageid === 1) language = '(English)'
          else if (item.languageid === 2) language = '(Spanish)'

          formatted[col.label] = `${caseType}\n${language}`.trim()
          break

        case 'attorneyContact':
          const facility = item.facility ? item.facility + '; ' : ''
          const contact = [item.attorneyEmail, item.attorneyTelephone].filter(Boolean).join('; ')
          const countryWithContact = [item.attorneyCountry, contact].filter(Boolean).join('; ')
          formatted[col.label] = [
            facility +
              [item.attorneyAddress, item.attorneyCityandState, countryWithContact]
                .filter(Boolean)
                .join(', '),
          ]
            .filter(Boolean)
            .join('')
          break

        case 'assignedToOthers':
          const htmlString = item[col.key] || ''
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = htmlString
          const plainText = tempDiv.textContent || tempDiv.innerText || ''
          const entries = plainText.split('),')
          const names = entries
            .map((entry) => {
              const match = entry.match(/^(.*?)\s*\(/)
              return match ? match[1].trim() : null
            })
            .filter(Boolean)
          if (name && !names.includes(name)) names.unshift(name)
          formatted[col.label] = names.join(',\n')
          break

        default:
          formatted[col.label] = item[col.key] || ''
          break
      }
    })
    return formatted
  })
}

export const generateXLSXFile = (filteredData, exportColumns, fileName, options = {}) => {
  const { colWidthsMap = {}, fileType = 'excel' } = options

  const isCSV = fileType === 'csv'
  const extension = isCSV ? 'csv' : 'xlsx'

  const worksheet = XLSX.utils.json_to_sheet(filteredData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'AttorneyData')
  if (!isCSV) {
    const range = XLSX.utils.decode_range(worksheet['!ref'])
    worksheet['!cols'] = worksheet['!cols'] || []

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: C })
      const colHeader = worksheet[headerCell]?.v

      worksheet['!cols'][C] = {
        wch: colWidthsMap[colHeader] || 19,
      }
    }

    const headerStyle = {
      fill: { fgColor: { rgb: '1F497D' } },
      font: { color: { rgb: 'FFFFFF' }, bold: true },
      alignment: { wrapText: true, vertical: 'middle', horizontal: 'center' },
    }

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
        const cell = worksheet[cellAddress]
        if (!cell) continue

        cell.s =
          R === 0
            ? headerStyle
            : {
                alignment: {
                  wrapText: true,
                  vertical: 'top',
                  horizontal: 'left',
                },
              }
      }
    }
  }

  XLSX.writeFile(workbook, `${fileName}.${extension}`, {
    bookType: extension,
    type: 'file',
  })
}

export const exportToCsvExcelOrPdf = ({
  data,
  exportColumns,
  name,
  fileNamePrefix,
  type = 'pdf',
  pdfOptions = {},
}) => {
  const formattedDate = getFormattedDate()
  const fileName = `${fileNamePrefix} ${name} ${formattedDate}`
  const filteredData = getFormattedExportData(data, exportColumns, name)

  if (type === 'csv' || type === 'excel') {
    generateXLSXFile(filteredData, exportColumns, fileName, {
      colWidthsMap: pdfOptions.colWidths || {},
      fileType: type,
    })
  } else if (type === 'pdf') {
    const {
      orientation = 'portrait',
      fontSize = 8,
      titleFontSize = 14,
      columnWidths = {},
      title = `All Defense Maps on the professional account of ${name} on ${formattedDate}`,
    } = pdfOptions

    const doc = new jsPDF({
      orientation: orientation,
      unit: 'mm',
      format: 'a4',
    })

    const pageWidth = doc.internal.pageSize.getWidth()
    doc.setFontSize(titleFontSize)
    doc.text(title, pageWidth / 2, 15, { align: 'center' })

    const tableColumn = exportColumns.map((col) => col.label)
    const tableRows = filteredData.map((item) => tableColumn.map((col) => item[col]))

    const columnStyles = {}
    tableColumn.forEach((colLabel, index) => {
      const width = columnWidths[colLabel]
      if (width) {
        columnStyles[index] = { cellWidth: width }
      }
    })

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      margin: { top: 20, left: orientation === 'landscape' ? 18 : 12 },
      styles: {
        fontSize: fontSize,
        overflow: 'linebreak',
        lineWidth: 0.2,
        lineColor: 200,
      },
      columnStyles: columnStyles,
    })

    doc.save(`${fileName}.pdf`)
  }
}

export const accordionConfig = [
  { key: 'a', title: 'A. Search All Maps', fields: ['firstName', 'lastName', 'emailAddress'] },
  {
    key: 'b',
    title: 'B. Search Maps made by clients not in detention',
    fields: ['firstName', 'lastName', 'emailAddress'],
  },
  {
    key: 'c',
    title: 'C. Search Maps made on all detention versions',
    fields: [
      'firstName',
      'lastName',
      'emailAddress',
      'attorneyFirstName',
      'attorneyLastName',
      'facility',
    ],
  },
]
